import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import moment from 'moment';
import styles from '../../assets/provider-tab.module.scss';
import { IProvider } from 'src/types/provider';
import { QueryParams } from 'src/types/grid';
import { Paginated } from 'src/services/api-handlers/pagination';
import Loader from 'src/components/Loader';
import SimpleCalendar from 'src/components/calendars/SimpleCalendar';
import ExpenseTable from './components/ExpenseTable';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { IExpense } from '../../../../../../../../types/expense';

export interface StateProps {
    data: Paginated<IExpense>;
    inProgress: boolean;
}
export interface DispatchProps {
    getData: (params: QueryParams) => void;
}
interface RouteParams {
    id: string;
    tab?: string;
}
export interface OwnProps {
    provider: Partial<IProvider> | null;
}

export interface Props extends StateProps, DispatchProps, OwnProps, RouteComponentProps<RouteParams> {}
const CaseSession: React.FunctionComponent<Props> = (props: Props) => {
    const { getData, provider, data, inProgress } = props;
    const [month, setMonth] = useState<{ monthEnd: string; monthStart: string }>({
        monthStart: moment().startOf('month').format('YYYY-M-D'),
        monthEnd: moment().endOf('month').format('YYYY-M-D'),
    });

    useEffect(() => {
        if (provider && provider.id) {
            getData({
                page: 1,
                filters: {
                    'provider.id': provider.id,
                    'expenseDate[before]': month.monthEnd,
                    'expenseDate[after]': month.monthStart,
                    //  'order[seanceDate]': 'asc',
                },
                itemsPerPage: 1200,
            });
        }

        // eslint-disable-next-line
    }, [getData, props.match.params?.tab, month]);

    const onChangeDate = (date: Date) => {
        const monthStart = moment(date).startOf('month').format('YYYY-M-D');
        const monthEnd = moment(date).endOf('month').format('YYYY-M-D');
        setMonth({
            monthStart,
            monthEnd,
        });
    };

    return (
        <div className={classNames(styles.tabWrap, 'tabWrapSession')}>
            <SimpleCalendar
                setDate={(val) => false}
                navigateDate={onChangeDate}
                containerClassName={`onlyHeaderDatepicker`}
                open={'date'}
                view={'month'}
            />
            {inProgress ? <Loader /> : null}

            <div className={classNames(styles.tabsSessions)}>
                <ExpenseTable data={data} month={month} provider={provider} />
            </div>
        </div>
    );
};

export default withRouter(CaseSession);
